module.exports = __webpack_public_path__ + "static/media/cafe.7ccc7373.svg";